import PropTypes from "prop-types";
import React from "react";

export default class VerticalModalListListItemMarker extends React.PureComponent {
  static displayName = "VerticalModalListListItemMarker";

  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  };

  get className() {
    const base = "vertical-modal-list-item-marker";

    return base;
  }

  render() {
    return <div className={this.className}>{this.props.children}</div>;
  }
}
